import { downloadBlob, getJson, postForFile } from './batch3Api';

export { downloadBlob };

export interface LedgerPdfFormat {
  key: string;
  label: string;
  mapping_available: boolean;
}

export interface LedgerPdfSummary {
  format: string;
  transactions: number;
  ap_codes: number;
  columns: number;
  mapping_rows: number;
  mapping_ap_codes: number;
  mapping_note: string | null;
  files: string[];
}

export async function fetchLedgerPdfFormats(): Promise<LedgerPdfFormat[]> {
  const data = await getJson<{ formats: LedgerPdfFormat[] }>('/ledger-pdf/formats', 'Could not load the PDF formats');
  return data.formats;
}

export function convertLedgerPdf(file: File, format: string) {
  const form = new FormData();
  form.append('input_file', file);
  form.append('options', JSON.stringify({ format }));
  return postForFile<LedgerPdfSummary>('/ledger-pdf/convert', form, 'ledger_converted.zip', 'Conversion failed');
}
